var mp = mp || {};

// FancyBox
//-----------------------------------------------------------------
mp.fancyBox = function() {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }
    
    $trigger.fancybox({
        infobar: false,
        buttons: [
            "close"
        ],
    });
};


// Partner Popup
//-----------------------------------------------------------------
mp.popupPartner = function($src) {
    $.fancybox.close(true);
    $.fancybox.open({
        closeExisting : true,
        src : '#popup-'+$src,
        type : 'inline',
    });
}




// Background image holder
//-----------------------------------------------------------------
mp.backgroundHolder = function() {
    var $element = $(".background-holder");

    if (!$element.length) {
        return;
    }

    $element.each(function(){
        var $img = $(this).find('img');
        var $imageSrc = $img.attr('src');
        $img.remove();
        $(this).css('background-image', 'url('+$imageSrc+')').addClass('show');
    });
};



// ScrollTO
//-----------------------------------------------------------------
mp.scrollTo = function() {

    var $trigger = $("[data-scroll]");

    if (!$trigger.length) {
        return;
    }
    
    $trigger.on('click', function(e){
        e.preventDefault();

        var dataID = '#'+$(this).data('scroll');

        $.scrollTo(dataID, 800, {
            'axis':'y',
            'offset': 0,
        });
    })
};



// Custom Select
//-----------------------------------------------------------------
mp.customSelect = function() {

    var $element = $(".select--single");

    if (!$element.length) {
        return;
    }
    
    $element.selectric({
        maxHeight: 260,
    });
};


// Datepicker
//-----------------------------------------------------------------
mp.datepicker = function() {
    var $element = $("#datepicker");

    if (!$element.length) {
        return;
    }
    
    var picker = new Pikaday({ 
        field: document.getElementById('datepicker'),
        format: 'DD.MM.YYYY.',
        defaultDate: moment().add(1, 'days').toDate(),
        minDate: moment().add(1, 'days').toDate(),
    });
};



// Tabs
//-----------------------------------------------------------------
mp.tabs = function() {
    var $element = $(".tabs");

    if (!$element.length) {
        return;
    }

    $(document).on('click', '.tabs [data-toggle]', function(e){
        e.preventDefault();
        
        var $tabID = $(this).data("toggle");

        $(this).parents('.tabs').find("[data-toggle], .tabs__content").removeClass("active");
        
        $(this).parents('.tabs').find(".tabs__nav [data-toggle='"+$tabID+"']").addClass("active");
        $(this).parents('.tabs').find("#"+$tabID).addClass("active");
    })
};




$(document).ready(function (){
    mp.fancyBox();
    mp.backgroundHolder();
    mp.scrollTo();
    mp.customSelect();
    mp.datepicker();
    mp.tabs();
});